import { jsPDF } from 'jspdf';

export const generatePDFFromImage
  = async (imageUrl: string, name: string): Promise<void> => {
    const response = await fetch(imageUrl, {
      cache: 'no-cache',
    });
    const blob = await response.blob();

    const base64 = await new Promise<string>(
      (resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      },
    );

    const image = new Image();
    image.src = base64;

    await new Promise(resolve => (image.onload = resolve));

    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgRatio = image.width / image.height;
    let imgWidth = pageWidth;
    let imgHeight = imgWidth / imgRatio;

    if (imgHeight > pageHeight) {
      imgHeight = pageHeight;
      imgWidth = imgHeight * imgRatio;
    }

    const x = (pageWidth - imgWidth) / 2;
    const y = (pageHeight - imgHeight) / 2;

    pdf.addImage(base64, 'PNG', x, y, imgWidth, imgHeight);
    pdf.save(`${name}.pdf`);
  };
